"use strict";

exports.__esModule = true;
var _ReportingPeriodController = require("./ReportingPeriodController");
Object.keys(_ReportingPeriodController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportingPeriodController[key]) return;
  exports[key] = _ReportingPeriodController[key];
});